import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import config from 'config';
import {
  getCollectionPageData,
  updateCollectionRenderData,
  updateCollectionData,
} from './../../../actionCreators/collectionPage';
import { whatsappCapturePhoneNumber } from '../../../actionCreators/phoneNumberCapture';
import { changeLogo } from '../../../actionCreators/common'; // getRedisRouter
import {
  isEmptyObject,
  showElement,
  isSearchCrawler,
  extractUtmSourceFromUrl,
} from '../../../utils/helper';
import { getDTMCategory, setWindowDtm } from '../../../utils/DTM';
import { setAndTriggerDataLayer } from '../../../utils/DataLayer';
import JSONPageLoader from '../../components/JSONPageLoader/JSONPageLoader';
import PhoneNumberCapture from '../PhoneNumberCapture/PhoneNumberCapture';
import Header from '../../components/MyAccount/Header';
import { langCodeAllowed } from '../../../locales';
import localStorageHelper from '../../../utils/localStorageHelper';

class CollectionPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAfterScroll: false,
      showPhnCapture: true,
    };
    this.processingScroll = false;
    this.handleScroll = this.handleScroll.bind(this);
    this.key = '';
    this.getUserPhoneNumber = this.getUserPhoneNumber.bind(this);
    this.triggerTracking = this.triggerTracking.bind();
  }

  componentDidMount() {
    const repeatFlowPhoneCapture = localStorageHelper.getItem('repeatFlowPhoneCapture');
    repeatFlowPhoneCapture ? null : localStorageHelper.setItem('repeatFlowPhoneCapture', 'false');
    const {
      isDesktopExchange,
      colUrl,
      collectionData,
      renderCollectionData,
      pathname,
      isExchange,
    } = this.props;
    if (isDesktopExchange) {
      this.props.getCollectionPageData(`${config.jsonFireBasePath}/${this.props.collectionUrl}`);
    } else if (isEmptyObject(collectionData)) {
      this.props.getCollectionPageData(colUrl);
    }
    const keyArr = colUrl.split('/');
    this.key = keyArr[keyArr.length - 1].replace('.json', '').replace(/\-/g, '');
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    if (
      collectionData.result &&
      renderCollectionData &&
      renderCollectionData.length === collectionData.result.length
    ) {
      showElement('#app-footer', true);
    } else {
      showElement('#app-footer', false);
    }
    if (!isDesktopExchange) {
      const category = getDTMCategory(pathname) || pathname.slice(1);
      this.triggerDtm(category);
      this.triggerTrackingEvents();
      this.setLogo();
      this.triggerTracking(this.props.userInfo);
    }
    if (isExchange) {
      showElement('header.header', false);
      showElement('#app-footer', false);
    }
    if (typeof window.clevertap !== 'undefined') {
      window.clevertap.event.push('Page Visited', {
        pageName: 'pre listing page',
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { redisCommonData } = this.props;
    if (prevProps.redisCommonData !== redisCommonData) {
      this.setLogo();
    }
  }

  componentWillUnmount() {
    if (this.campaignTimeout) {
      clearTimeout(this.campaignTimeout);
    }
    window.removeEventListener('scroll', this.handleScroll);
    if (this.props.isExchange) {
      showElement('#app-footer', true);
      showElement('header.header', true);
    } else {
      showElement('#app-footer', true);
    }
  }

  getUserPhoneNumber() {
    const { whatsappCapturePhoneNumber } = this.props;
    whatsappCapturePhoneNumber();
  }

  setLogo() {
    try {
      const { pathname: path, redisCommonData, changeLogo } = this.props;
      if (
        redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
        JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).listing === 'ON'
      ) {
        if (
          path.toLowerCase()?.indexOf('sun') > -1 ||
          path.toLowerCase()?.indexOf('contact') > -1 ||
          path.toLowerCase()?.indexOf('solution') > -1 ||
          path.toLowerCase()?.indexOf('accessor') > -1 ||
          path.toLowerCase()?.indexOf('reading') > -1
        ) {
          changeLogo('dealskart');
        } else {
          changeLogo('lenskart');
        }
      } else {
        changeLogo('lenskart');
      }
    } catch (error) {
      console.log(error);
    }
  }

  handleScroll() {
    const { redisCommonData } = this.props;
    const phoneCaptureConfig =
      redisCommonData &&
      redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW &&
      JSON.parse(redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW);
    const scrollPixel = phoneCaptureConfig && phoneCaptureConfig?.collection?.scrollPixel;
    if (this.processingScroll) {
      return;
    }
    this.processingScroll = true;
    const { collectionData, renderCollectionData, updateCollectionRenderData, isExchange } =
      this.props;
    const sT = window.pageYOffset;
    const dBody = document.body;
    const dHtml = document.documentElement;
    const dHeight = Math.max(
      dBody.scrollHeight,
      dBody.offsetHeight,
      dHtml.clientHeight,
      dHtml.scrollHeight,
      dHtml.offsetHeight
    );
    if (collectionData.result) {
      if (
        renderCollectionData.length < collectionData.result.length &&
        window.innerHeight + sT > dHeight - 150
      ) {
        const concatData = collectionData.result.slice(
          renderCollectionData.length,
          renderCollectionData.length + 4
        );
        updateCollectionRenderData(concatData);
      } else if (renderCollectionData.length === collectionData.result.length && !isExchange) {
        showElement('#app-footer', true);
      }
    }
    this.processingScroll = false;

    if (window.scrollY > scrollPixel) {
      this.setState({
        showAfterScroll: true,
      });
    }
  }

  mergeCampaignDataWithCollectionData = () => {
    const { pristineCollectionData, updateCollectionData } = this.props;
    const data = JSON.parse(JSON.stringify(pristineCollectionData.result));
    updateCollectionData(data);
  };

  triggerDtm(category) {
    const { isExchange } = this.props;
    const dtm = {};
    dtm.pageType = 'category page';
    dtm.pageName = `web|${category}|category page`;
    dtm.channel = 'web|category page';
    dtm.subSection1 = `web|category page|${category}`;
    dtm.subSection2 = `web|category page|${category}${isExchange ? '-exchange product' : ''}`;
    dtm.category = category;
    dtm.event = 'product-category';
    if (isExchange) {
      dtm.exchangeType = 'NEWPRODUCT';
    }
    setWindowDtm(dtm);
  }

  triggerTrackingEvents() {
    const { localeInfo } = this.props;
    const { domain } = localeInfo;
    if (document.readyState === 'complete') {
      const { fbq, location } = window;
      if (typeof fbq !== 'undefined') {
        fbq('track', 'PageView');
      }
      /** Data Layer Starts */
      const dlUpdate = {};
      dlUpdate.visitorStore = domain;
      dlUpdate.visitorPageTypeInfo = 'Static';
      dlUpdate.visitorPageType = 'SubCategory';
      dlUpdate.PageUrl = location.href;
      setAndTriggerDataLayer(dlUpdate);
      /** Data Layer Ends */
    } else {
      setTimeout(() => {
        this.triggerTrackingEvents();
      }, 2000);
    }
  }

  triggerTracking(userInfo) {
    const {
      utm_source = null,
      utm_medium = null,
      utm_campaign = null,
      utm_term = null,
      utm_content = null,
    } = extractUtmSourceFromUrl(location.search);
    if (utm_source) {
      localStorage.setItem(
        'utmSource',
        JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
      );
    } else if (!localStorage.getItem('utmSource')) {
      localStorage.setItem(
        'utmSource',
        JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
      );
    }
    const utmSource = JSON.parse(localStorage.getItem('utmSource'));
    const dlUpdate = {
      event: 'VirtualPageView',
      PageUrl: location.href,
      pageType: 'Select classic Range Product',
      mobile: btoa(userInfo?.result?.telephone),
      email: btoa(userInfo?.result?.email),
      loginStatus: userInfo?.result?.login ? 'loggedIn' : 'guest',
      lkUserType: userInfo?.result?.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
      customerID: userInfo?.result?.id,
      countryCode: userInfo?.result?.countryCode,
      currencyCode: userInfo?.result?.currencyCode,
      website_source: `${userInfo?.result?.countryCode} headless`,
      utmSource: utmSource.utm_source || '(direct)',
      utmMedium: utmSource.utm_medium || '(none)',
      utmCampaign: utmSource.utm_campaign || '(direct)',
      utmTerm: utmSource.utm_term || '',
      utmContent: utmSource.utm_content || '',
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(dlUpdate);
    else {
      setTimeout(() => {
        window.dataLayer.push(dlUpdate);
      }, 2000);
    }
  }

  handlePhnCaptureBS = () => {
    localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
    this.setState({
      showPhnCapture: !this.state.showPhnCapture,
    });
  };
  render() {
    const {
      isDesktopExchange,
      location,
      localeInfo,
      pathname,
      collectionData,
      renderCollectionData,
      history,
      isExchange,
      dataLocale,
      dataLocale: { CHOOSE_FRAME_STYLE },
      redisCommonData,
    } = this.props;
    const { domain } = localeInfo;
    const repeatFlowPhoneCapture = localStorageHelper.getItem('repeatFlowPhoneCapture');
    const phoneCaptureConfig =
      redisCommonData &&
      redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW &&
      JSON.parse(redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW);
    const buyWithCallConfig =
      redisCommonData?.BUY_ON_CALL_WIDGET && JSON.parse(redisCommonData.BUY_ON_CALL_WIDGET);
    let metaData = {};
    if (collectionData && collectionData.result && collectionData.result.metaData) {
      metaData = collectionData.result.metaData;
    }
    const metaNames = metaData.metaName || {};
    const metaDataArr = [];
    const linkTags = [];
    const { SEO_ALTERNATE_STATIC_PAGES } = redisCommonData || {};
    const dataSeoAlternateFirebase =
      SEO_ALTERNATE_STATIC_PAGES && JSON.parse(SEO_ALTERNATE_STATIC_PAGES);
    if (!dataSeoAlternateFirebase?.[location.pathname]?.canonical) {
      Object.keys(metaNames).forEach(key => {
        metaDataArr.push({ name: key, content: metaNames[key] });
      });
      const metaProperties = metaData.metaProperty || {};
      Object.keys(metaProperties).forEach(key => {
        metaDataArr.push({ property: key, content: metaProperties[key] });
      });
      const linkTags = [
        { rel: 'canonical', href: `${domain}${pathname}` },
        { rel: 'alternate', href: `${domain}${pathname}` },
        { rel: 'alternate', href: `${domain}${pathname}`, hreflang: 'x-default' },
      ];
      Object.keys(langCodeAllowed).forEach(key => {
        linkTags.push({
          rel: 'alternate',
          hrefLang: langCodeAllowed[key]?.hrefLang?.toLowerCase(),
          href: `${langCodeAllowed[key].domain}${location.pathname}${location.search}`,
        });
      });
    }
    if (collectionData.amphtml) linkTags.push({ rel: 'amphtml', href: `${domain}/amp${pathname}` });
    return (
      <React.Fragment>
        {!isDesktopExchange && (
          <Helmet link={linkTags} meta={metaDataArr} title={metaData.title}></Helmet>
        )}
        {isExchange && <Header enableSearch navLink history={history} title={CHOOSE_FRAME_STYLE} />}
        {!isDesktopExchange &&
          !isExchange &&
          !isSearchCrawler() &&
          this.state.showPhnCapture &&
          !isSearchCrawler() &&
          this.state.showAfterScroll &&
          phoneCaptureConfig?.collection?.isShow &&
          repeatFlowPhoneCapture !== 'true' && (
            <PhoneNumberCapture
              dataLocale={dataLocale}
              dtmLinkPageName="web|collection|collection"
              handleClose={() => this.handlePhnCaptureBS()}
              page="collection"
            ></PhoneNumberCapture>
          )}
        <JSONPageLoader
          buyWithCallConfig={buyWithCallConfig}
          dataLocale={dataLocale}
          history={history}
          isDesktopExchange={isDesktopExchange}
          renderData={renderCollectionData}
          whatsappCapturePhoneNumber={this.getUserPhoneNumber}
        ></JSONPageLoader>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  colUrl: state.collectionPage.colUrl,
  pristineCollectionData: state.collectionPage.pristineCollectionData,
  collectionData: state.collectionPage.collectionData,
  renderCollectionData: state.collectionPage.renderCollectionData,
  redisCommonData: state.common.redisCommonData,
  isExchange: state.returnExchange.isExchange,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
  userInfo: state.common.userInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    getCollectionPageData: val => dispatch(getCollectionPageData(val)),
    updateCollectionRenderData: data => dispatch(updateCollectionRenderData(data)),
    updateCollectionData: data => dispatch(updateCollectionData(data)),
    changeLogo: logo => dispatch(changeLogo(logo)),
    whatsappCapturePhoneNumber: () => dispatch(whatsappCapturePhoneNumber()),
  };
}

CollectionPage.propTypes = {
  colUrl: PropTypes.string,
  collectionData: PropTypes.object,
  renderCollectionData: PropTypes.array,
};

CollectionPage.defaultProps = {
  colUrl: '',
  collectionData: {},
  renderCollectionData: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPage);
